






































































































































































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { setStorage } from "@common/utils";
import { WebsiteCommonService } from "@/zh-website/src/service/data-service/website";
import { WebsiteCommonApi } from "@/zh-website/src/api/website";

@Component({
  components: {}
})
export default class Menu extends Vue {
  isActive = -1;
  isShow = 0;
  isType = false;
  asdadg = true;
  adcs = 0;
  showSearch = false;
  activess = 1;
  dfdfg = false;
  isthf = true;
  navIndex = [
    // {
    //   name: "浙江华为",
    //   link: "/home/page",
    //   // desc: "Homepage",
    //   child: [

    //   ]
    // },
    {
      name: "关于浙江华为",
      link: "/home/aboutus",
      // desc: "Aboutus",
      child: []
    },
    {
      name: "新闻中心",
      link: "/home/news/page",
      // desc: "Content",
      child: [
        // { name: '近期新闻', link: '/home/news/page' },
        // { name: '专题报道', link: '/home/report' }
      ]
    },
    {
      name: "招聘中心",
      link: "/home/recruit/page",
      // desc: "Recruitment",
      child: [
        { name: "社会招聘", link: "/home/recruit/social" },
        { name: "校园招聘", link: "/home/recruit/campus" }
      ]
    }
  ];
  navSecond = [
    {
      name: "行业人才发展",
      link: "/enterprise/page",
      child: [] as any
    },
    {
      name: "产品技术培训",
      link: "/enterprise/product/page",
      // desc: "DESC",
      child: [] as any
    },
    {
      name: "数字化领导力",
      link: "/enterprise/digital/page",
      // desc: "Digital leadership",
      child: [
        // { name: "高研班", link: "/enterprise/digital/share/1" },
        // { name: "特训营", link: "1" },
        // { name: "工作坊", link: "/enterprise/digital/training/1" },
      ] as any
    },
    {
      name: "成功案例",
      link: "/enterprise/all-success-case",
      // desc: "DESC",
      child: []
    },
    {
      name: "华为认证",
      // link: "/enterprise/authent/page",
      link: "/enterprise/authent/1",
      // desc: "DESC",
      child: [
        // { name: "概述", link: "/enterprise/authent/summary/1" },
        // { name: "认证类别", link: "/enterprise/authent/category/2" },
        // { name: "认证等级", link: "/enterprise/authent/grade/3" },
        // { name: "开班计划", link: "/enterprise/authent/Study/4" }
      ]
    }
  ];
  navThird = [
    {
      name: "首页",
      link: "/partner/page",
      //  desc: "Index",
      child: []
    },
    {
      name: "行业专家合作",
      link: "/partner/industry/page/0",
      // desc: "DESC",
      child: [
        { name: "专家权益", link: "/partner/industry/page/2" },
        { name: "常见问题", link: "/partner/industry/page/3" },
        { name: "申请加入", link: "/partner/industry/page/4" }
      ]
    },
    // {
    //   name: "精品课程合作",
    //   link: "/partner/course/1",
    //   // desc: "CASE",
    //   child: [
    //     { name: "面授课程合作", link: "/partner/course/1" },
    //     { name: "在线课程合作", link: "/partner/course/2" },
    //     { name: "课程案例合作", link: "/partner/course/3" }
    //   ]
    // },
    {
      name: "渠道合作",
      link: "/partner/channel/1",
      child: []
    },
    {
      name: "供应商专区",
      link: "/partner/supplier",
      child: []
    }
  ];
  navFour = [
    {
      name: "产品与解决方案",
      link: "/colleges/page",
      // desc: "Index",
      child: [] as any[]
    },
    {
      name: "院校案例",
      link: "/colleges/caseDetail/1",
      // desc: "DESC",
      child: [] as any[]
    },
    {
      name: "教育合作",
      link: "/colleges/teach/1",
      // desc: "DESC",
      child: [] as any[]
    },
    {
      name: "华为认证",
      // link: "/colleges/authent/summary",
      link: "/colleges/authent/1",
      // desc: "DESC",
      child: [] as any[]
    }
  ];
  navs: any = [];
  navsTab: any = [];
  navTop: any = [];
  navTopFirst = [
    { name: "政企用户", link: "/enterprise" },
    { name: "高校用户", link: "/colleges/page", child: [] },
    { name: "个人用户", link: "/", wlink: "https://www.ictxuetang.com" },
    { name: "合作伙伴", link: "/partner" }
  ];
  navTopSecond = [
    // { name: "我是", link: "/" },
    { name: "新闻中心", link: "/home/news" },
    { name: "招聘中心", link: "/home/recruit" },
    // { name: "服务中心", link: "/home/service" },
    { name: "关于浙江华为", link: "/home/aboutus" }
  ];
  industry = {
    "0037005": "数字政府",
    // '0037004': '交通',
    "0037006": "金融",
    "0037001": "电力"
    // '0037002': '公共安全'
    // "0037003": "广电媒资",
  };
  partner = {
    "0052003": "主题演讲",
    "0052002": "协同育人",
    "0052001": "教材编写"
  };
  //watch
  @Watch("$route", { immediate: true })
  onRouteChange(route) {
    this.ss();
    this.activess = this.$route.meta?.serial;
  }
  @Watch("navs", { immediate: true })
  handler(item) {
    // console.log("item,", item);
    this.navsTab = item.filter(item => {
      return item.name !== "浙江华为";
    });
  }
  mounted() {
    this.ss();
    this._getIndustryList();
    this._getPartnerList();
    this.getChannel();
    this.getCollegeNav();
    this.activess = this.$route.meta?.serial;
    // console.log(this.$route)
    if (this.$route.path == "/Colleges/Legal") {
      this.isthf = false;
    }
  }

  //methods
  getCollegeNav() {
    WebsiteCommonService.getNavigationList({
      typeList: 2
    }).then((res: any) => {
      // console.log("college", res);
      res.data.navigation.forEach((item: any, index: number) => {
        if (item.childNavigation) {
          item.childNavigation.forEach((element: any, type: number) => {
            let link = "";
            if (index == 0) link = `solve/profession/${element.id}`;
            else link = `caseDetail/${element.id}`;
            this.navFour[index].child.push({
              name: element.name,
              link: `/colleges/${link}`
            });
          });
        }
      });
    });
  }
  goHw() {
    window.open("https://www.huawei.com/", "_blank");
  }
  // 获取行业人才发展类别
  async _getIndustryList() {
    //通过接口获取数据
    WebsiteCommonService.getNavigationList({ typeList: 1 }).then((res: any) => {
      // console.log(res);
      res.data.navigation.forEach((item: any) => {
        //
        if (item.name == "行业人才发展") {
          this.navSecond[0].child.length = 0;
          item.childNavigation &&
            item.childNavigation.forEach((children: any) => {
              this.navSecond[0].child.push({
                name: children.name,
                link: "/enterprise/industry/classify/" + children.id
              });
            });
        } else if (item.name == "产品技术培训") {
          this.navSecond[1].child.length = 0;
          item.childNavigation &&
            item.childNavigation.forEach((children: any) => {
              this.navSecond[1].child.push({
                name: children.name,
                link: "/enterprise/product/classify/" + children.id
              });
            });
        } else if (item.name == "数字化领导力") {
          this.navSecond[2].child.length = 0;
          item.childNavigation &&
            item.childNavigation.forEach((children: any) => {
              this.navSecond[2].child.push({
                name: children.name,
                link: "/enterprise/digital/classify/" + children.id
              });
            });
        }
      });
    });
  }

  // 获取合作伙伴类别
  async _getPartnerList() {
    const result = {
      data: [
        {
          dictCode: "0052003",
          dictName: "主题演讲",
          id: "b3zOwzbOA63PC3rC30jk09kcqO01585287589708",
          sort: 0,
          isMenu: 0,
          group: "052",
          createDate: 1585316389000
        },
        {
          dictCode: "0052002",
          dictName: "协同育人",
          id: "2tv664hV3kNy214P7w730xn14JQ1585287579900",
          sort: 0,
          isMenu: 0,
          group: "052",
          createDate: 1585316379000
        },
        {
          updateDate: 1585316369000,
          dictCode: "0052001",
          dictName: "教材编写",
          id: "wsz1596g28NbMUJa055S820D2D91585279251180",
          sort: 0,
          isMenu: 0,
          group: "052",
          createDate: 1585308051000
        }
      ],
      total: 3
    };
    const data = result.data; //合作伙伴被写死了
    const id = JSON.stringify(this.partner);
    window.sessionStorage.setItem("partner", id);
  }
  //渠道合作
  async getChannel() {
    const _this = this;
    const result = {
      data: [
        {
          tag1: 0,
          updateDate: 1683533081000,
          plural: 0,
          reading: 0,
          collection: 0,
          sort: 1,
          tag2: 0,
          isShow: 1,
          tag3: 0,
          field1: "查询渠道伙伴",
          dictCode: "036",
          content1:
            '<p><br/></p><p style="text-align: center;"><span style="text-align: center;"></span><span style="text-align: center; color: rgb(112, 112, 112); font-family: 微软雅黑, 黑体, 宋体; background-color: rgb(255, 255, 255);">渠道合作相关内容待开放，敬请期待</span></p>',
          id: "h59c13wjj4gRq98A066G02338I11585636693501",
          field2:
            "/file/2020-04-10/BlB29Lz6y68f4Sm1BWVv3S6J76K1586483116695.png",
          group: "036",
          createDate: 1585665493000
        },
        {
          tag1: 0,
          updateDate: 1632936458000,
          plural: 0,
          reading: 0,
          collection: 0,
          sort: 1,
          tag2: 0,
          isShow: 1,
          tag3: 0,
          field1: "了解政策权益",
          dictCode: "036",
          content2: "",
          content1:
            '<p><span style="text-align: center;"></span><br/></p><p style="text-align: center;"><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;"><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; text-align: center;"></span><span style="text-align: center; color: rgb(112, 112, 112); font-family: 微软雅黑, 黑体, 宋体; background-color: rgb(255, 255, 255);"></span></span></p><p style="text-align:center"><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;"><strong><span style="font-size: 21px;">关于规范渠道授权的通知</span></strong><strong><span style="font-size: 21px;"></span></strong><strong><span style="font-size: 21px;"></span></strong></span></p><p style="line-height:150%"><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;"><strong><span style="font-size: 16px; line-height: 150%;">致<span style="text-decoration: underline;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>：</span></strong><strong><span style="font-size: 16px; line-height: 150%;"></span></strong><strong><span style="font-size: 16px; line-height: 150%;"></span></strong></span></p><p style="text-indent:32px;line-height:150%"><span style="font-size: 16px; line-height: 150%; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">为维护市场秩序，保障双方的共同利益，我司将加强对渠道项目的商务授权管理，请按相关流程开展合作：<span style="font-size: 16px; line-height: 150%; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; color: red;"> </span></span></p><p style="text-indent:32px;line-height:150%"><span style="font-size: 16px; line-height: 150%; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">对于需开具商务《授权函》的项目，请渠道伙伴联系我方业务人员，相应项目经评审通过后，我方会以正式授权文件形式给予必要的商务支持。</span></p><p style="text-indent:32px;line-height:150%"><span style="font-size: 16px; line-height: 150%; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">对于未获得我司授权却以我司名义参与投标，若发生交付等各风险，我司有追责的权利；同时我司会按情节严重情况，考虑是否取消合作。</span></p><p style="text-align:left;text-indent:32px;line-height:150%"><span style="font-size: 16px; line-height: 150%; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">以上通知若合作中遇到问题，反馈。</span></p><p style="text-indent:32px;line-height:150%"><span style="font-size: 16px; line-height: 150%; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">特此通知。</span></p><p style="text-align: center;"><span style="text-align: center; color: rgb(112, 112, 112); font-family: 微软雅黑, 黑体, 宋体; background-color: rgb(255, 255, 255);"></span><br/></p><p><br/></p><p style="text-indent: 32px; line-height: 150%; text-align: right;"><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;"><strong><span style="font-size: 16px; line-height: 150%;">浙江华为通信技术有限公司</span></strong></span></p><p style="text-align: right;"><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;"><strong><span style="font-size: 16px; line-height: 150%; font-family: 宋体;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></strong></span>日期：2021年9月30日</p><p style="text-align: right;"><br/></p>',
          id: "N26Dg6C459EpayNCV66PjPsY81a1585636685540",
          field2:
            "/file/2020-04-10/B2qqmmspi6d3OL2Dr5nPt9ivzV61586483095587.png",
          group: "036",
          createDate: 1585665485000
        },
        {
          tag1: 0,
          updateDate: 1586511845000,
          plural: 0,
          reading: 0,
          collection: 0,
          sort: 1,
          tag2: 0,
          isShow: 1,
          tag3: 0,
          field1: "成为渠道伙伴",
          dictCode: "036",
          content1:
            '<p style="text-align: center;"><br/></p><p style="text-align: center;"><span style="color: rgb(112, 112, 112); font-family: 微软雅黑, 黑体, 宋体; text-align: center; background-color: rgb(255, 255, 255);">渠道合作相关内容待开放，敬请期待</span></p>',
          id: "yZ2508je79lmSU0Ulm9Ajz40F5P1581311981676",
          field2:
            "/file/2020-04-10/7Z44d9qE7e10G9X456795Cp22o61586483031054.png",
          group: "036",
          createDate: 1581340781000
        }
      ],
      total: 3
    };
    const arr: any = [];
    for (let i = 0; i < result.data.length; i++) {
      const obj: any = { name: "", link: "" };
      obj.name = result.data[i].field1;
      obj.link = "/partner/channel/" + (i + 1);
      arr.push(obj);
    }
    _this.navThird[2].child = arr;
    _this.navThird[2].link = arr[0].link;
  }

  showToggle(index) {
    this.isShow = index;
    this.activess = index + 1;
  }
  handleHide(index) {
    this.isShow = -1;
    this.activess = this.$route.meta?.serial;
  }
  showOpen() {
    this.dfdfg = !this.dfdfg;
  }
  mbopen(i) {
    this.adcs = i;
  }
  search() {
    this.showSearch = true;
    this.asdadg = false;
    this.$router.push("/home/search");
  }
  saveState(key, path) {
    localStorage.setItem("state", JSON.stringify(this.$store.state));
  }
  //跳转路由(中部导航)
  changeNav(key, path, k, wpath) {
    // console.log("-----", key, path, k, wpath);
    if (wpath != undefined) {
      // window.location.href = wpath;
      window.open(wpath, "_blank");
    } else {
      this.$router.push(path);
    }

    this.dfdfg = !this.dfdfg;
  }
  backIndex() {
    this.dfdfg = false;
    this.$router.push("/");
  }
  //跳转路由(顶部导航)
  changeNavTop(key, path, wpath) {
    if (wpath != undefined) {
      // window.location.href = wpath;
      window.open(wpath, "_blank");
    } else {
      this.$router.push(path);
    }
  }
  ss() {
    // 避免第一个渲染的显示
    this.isShow = -1;
    this.adcs = -1;
    // console.log(this.$route);
    if (this.$route.path == "/home/page") {
      this.isType = false;
    } else {
      this.isType = true;
    }
    // window.addEventListener("unload", this.saveState);
    if (this.$route.meta?.type == 6) {
      this.navs = this.navIndex;
      this.navTop = this.navTopFirst;
    } else if (this.$route.meta?.type == 5) {
      this.navs = this.navIndex;
      this.navTop = this.navTopFirst;
    } else if (this.$route.meta?.type == 4) {
      this.navs = this.navFour;
      this.navTop = this.navTopSecond;
    } else if (this.$route.meta?.type == 3) {
      this.navs = this.navThird;
      this.navTop = this.navTopSecond;
    } else if (this.$route.meta?.type == 2) {
      this.navs = this.navSecond;
      this.navTop = this.navTopSecond;
    } else {
      this.navs = this.navIndex;
      this.navTop = this.navTopFirst;
    }
    // this.isActive = this.$store.state.activeIndexs;
  }
}
